import React from "react";
import { techstack } from "../constants/aboutMeData";
import "../styles/techstack.css";

const TechStack = () => {
	return (
		<div className="techstack_container">
			<h1>Tech Stack</h1>
			<div className="tech-stack">
				{/* FRONTEND */}
				<div className="frontend">
					<h2>Frontend</h2>
					<ul>
						{techstack[0].frontend?.map((item, index) => (
							<li key={index}>
								<img
									src={item.img}
									alt={item.alt}
									width={32}
									height={32}
									loading="lazy"
								/>
								<span>{item.name}</span>
							</li>
						))}
					</ul>
				</div>

				{/* BACKEND */}
				<div className="backend">
					<h2>Backend</h2>
					<ul>
						{techstack[0].backend?.map((item, index) => (
							<li key={index}>
								<img
									src={item.img}
									alt={item.alt}
									width={32}
									height={32}
									loading="lazy"
								/>
								<span>{item.name}</span>
							</li>
						))}
					</ul>
				</div>

				{/* TOOLS */}
				<div className="tools">
					<h2>Tools</h2>
					<ul>
						{techstack[0].tools?.map((item, index) => (
							<li key={index}>
								<img
									src={item.img}
									alt={item.alt}
									width={32}
									height={32}
									loading="lazy"
								/>
								<span>{item.name}</span>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default TechStack;
